import Configurator from "./configurator.js";
import Executor from "./executor.js";
import Corrector from "./corrector.js";
import LanguageIcon from "@mui/icons-material/Language";
import description from "./description.js";

export default {
  title: "Conjugaison (verbes)",
  icon: LanguageIcon,
  description,
  Configurator,
  Executor,
  Corrector,
};
